import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IContentManagementAppState } from '../../../App.types';
import { requestComponents } from './Components.actions';
import { ComponentsReducerName } from './Components.types';

export function useComponents(componentId: string = null) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestComponents());
  }, []);

  const state = useSelector((appState: IContentManagementAppState) => appState[ComponentsReducerName]);

  return {
    ...state,
    selectedComponent: componentId === null ? null : state.components?.find((p) => p.id === componentId),
  };
}
